/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<1f95185a3d8ad509806b0e774a7013f2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpObjectRequestForm$data = {
  readonly displayLink: string | null | undefined;
  readonly entityKey: string | null | undefined;
  readonly icon: {
    readonly iconUrlV2: string;
  } | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "helpObjectRequestForm";
};
export type helpObjectRequestForm$key = {
  readonly " $data"?: helpObjectRequestForm$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectRequestForm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "helpObjectRequestForm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayLink",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HelpObjectStoreIcon",
      "kind": "LinkedField",
      "name": "icon",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "iconUrlV2",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityKey",
      "storageKey": null
    }
  ],
  "type": "HelpObjectStoreRequestForm",
  "abstractKey": null
};

(node as any).hash = "8c1fc8c576c89682f6b94f955fffd1ab";

export default node;
